/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaoBaoCopyProductVo } from './TaoBaoCopyProductVo';
import {
    TaoBaoCopyProductVoFromJSON,
    TaoBaoCopyProductVoFromJSONTyped,
    TaoBaoCopyProductVoToJSON,
    TaoBaoCopyProductVoToJSONTyped,
} from './TaoBaoCopyProductVo';

/**
 * 
 * @export
 * @interface ResponseListTaoBaoCopyProductVo
 */
export interface ResponseListTaoBaoCopyProductVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListTaoBaoCopyProductVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListTaoBaoCopyProductVo
     */
    message?: string;
    /**
     * 
     * @type {Array<TaoBaoCopyProductVo>}
     * @memberof ResponseListTaoBaoCopyProductVo
     */
    data?: Array<TaoBaoCopyProductVo>;
}

/**
 * Check if a given object implements the ResponseListTaoBaoCopyProductVo interface.
 */
export function instanceOfResponseListTaoBaoCopyProductVo(value: object): value is ResponseListTaoBaoCopyProductVo {
    return true;
}

export function ResponseListTaoBaoCopyProductVoFromJSON(json: any): ResponseListTaoBaoCopyProductVo {
    return ResponseListTaoBaoCopyProductVoFromJSONTyped(json, false);
}

export function ResponseListTaoBaoCopyProductVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListTaoBaoCopyProductVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TaoBaoCopyProductVoFromJSON)),
    };
}

export function ResponseListTaoBaoCopyProductVoToJSON(json: any): ResponseListTaoBaoCopyProductVo {
    return ResponseListTaoBaoCopyProductVoToJSONTyped(json, false);
}

export function ResponseListTaoBaoCopyProductVoToJSONTyped(value?: ResponseListTaoBaoCopyProductVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TaoBaoCopyProductVoToJSON)),
    };
}

